import './LoadingBars.scss';

export default function LoadingBars({ numberOfRows = 5, style = {}, size = 'regular', barHeight = 16 }: { numberOfRows?: number, style?: React.CSSProperties, size?: 'regular' | 'small', barHeight?: number }) {
  return <>
    <div className="loading-bars" style={style}>
      {
        new Array(numberOfRows).fill(null).map((_, i) =>
          <div key={i} className={`loading-bar ${size}`} style={{ height: barHeight }}></div>
        )
      }
    </div>
  </>
}
